import React from "react";
import { NATURAL_FEATURE_LABELS } from "../../constants/bothies";

const FeaturesList = ({ features }) => {
  if (!features) {
    return <span>No natural features detected.</span>;
  }

  const visibleFeatures = Object.entries(features).filter(
    ([key, isPresent]) => isPresent && NATURAL_FEATURE_LABELS[key]
  );

  if (visibleFeatures.length === 0) {
    return <span>No natural features detected.</span>;
  }

  return (
    <>
      {visibleFeatures.map(([key]) => (
        <span key={key} className="chip chip--muted">
          {NATURAL_FEATURE_LABELS[key]}
        </span>
      ))}
    </>
  );
};

export default FeaturesList;
